export const reportsData = {
  id: 1,
  name: "allReports",
  label: "Choose you report:"
};
